/**
 * File defining all datasources needed when dealing with Onaps forms
 */
import { getEnumValues } from "../../utils/enum.tools";
import { I18nOnaps } from "./onaps.i18n";
import { ONAPS_STATE_OR_PATHOLOGIES, PCS, SPORT_ACTIVITY_MODE } from "./onaps.types";

const i18n = I18nOnaps();

export enum OnapsDataSourceUid {
    PCS = "PCS",
    ONAPS_STATE_OR_PATHOLOGIES = "ONAPS_STATE_OR_PATHOLOGIES",
    SPORT_ACTIVITY_MODE = "SPORT_ACTIVITY_MODE"
}

export const PCS_DATA: { id: PCS, val: string }[] = getEnumValues<PCS>(PCS).map((v) => { return { id: v, val: i18n.pcs[v] }; });

export const ONAPS_STATE_OR_PATHOLOGIES_DATA: { id: ONAPS_STATE_OR_PATHOLOGIES, val: string }[] = getEnumValues<ONAPS_STATE_OR_PATHOLOGIES>(ONAPS_STATE_OR_PATHOLOGIES)
    .map((v) => { return { id: v, val: i18n.stateOrPathologies.general[v] }; });

export const SPORT_ACTIVITY_MODE_DATA: { id: SPORT_ACTIVITY_MODE, val: string }[] = getEnumValues<SPORT_ACTIVITY_MODE>(SPORT_ACTIVITY_MODE)
    .map((v) => { return { id: v, val: i18n.sportActivityMode[v] }; });
